export class DxParamsModel {
    constructor(
        public filter: string = null,
        public sort: string = null,
        public group: string = null,
        public skip: number = 0,
        public take: number = 0,
        public parameters: { [key: string]: any } = [],
    ) { }
}